import { render } from "./LeaderCard.vue?vue&type=template&id=7961147b"
import script from "./LeaderCard.vue?vue&type=script&lang=js"
export * from "./LeaderCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vdzeer/Projects/movesmart-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__